import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser, loginWithQR } from "../../store/authSlice";
import QRScanner from "../../components/auth/QRScanner";
import { companyLogo, backgroundImage } from "../../config";

const Login = () => {
  const [loginMethod, setLoginMethod] = useState("traditional");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleTraditionalLogin = async (e) => {
    e.preventDefault();
    setError(""); // Clear previous error
    if (!username || !password) {
      setError("Please fill in all fields");
      return;
    }
    try {
      const resultAction = await dispatch(loginUser({ username, password }));
      if (loginUser.fulfilled.match(resultAction)) {
         navigate("/dashboard", { replace: true });
      } else if (loginUser.rejected.match(resultAction)) {
        setError(resultAction.payload || "Login failed");
      }
    } catch (err) {
      setError("An unexpected error occurred");
    }
  };

  const handleQRLoginSuccess = async (userData) => {
    try {
      const resultAction = await dispatch(loginWithQR(userData));
      if (loginWithQR.fulfilled.match(resultAction)) {
        navigate("/dashboard", { replace: true });
      }
    } catch (err) {
      setError("QR login failed");
    }
  };
  const handleLeaveSignIn = () => {
    navigate("/homepage");
  };
  return (
    <div
      className="min-h-screen bg-no-repeat bg-cover bg-center flex items-center justify-center p-4"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="bg-white dark:bg-coolGray-750 rounded-2xl shadow-xl w-full max-w-md overflow-hidden">
        {/* Logo Section */}
        <div className="p-8 text-center">
          <div className="h-20 w-20 bg-primary-500 rounded-xl mx-auto mb-4 flex items-center justify-center">
            <img src={companyLogo} alt="AIS Logo" className="h-full w-full" />
          </div>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">
            Welcome Back!
          </h2>
          <p className="text-gray-500 dark:text-gray-400">
            Sign in to your account
          </p>
        </div>

        {/* Login Method Toggle */}
        <div className="flex border-b border-gray-200 dark:border-coolGray-650">
          <button
            type="button" // Add this attribute
            className={`flex-1 py-4 text-sm font-medium transition-colors ${
              loginMethod === "traditional"
                ? "text-primary-600 border-b-2 border-primary-500"
                : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
            onClick={() => setLoginMethod("traditional")}
          >
            Username & Password
          </button>
          <button
            type="button" // Add this attribute
            className={`flex-1 py-4 text-sm font-medium transition-colors ${
              loginMethod === "qr"
                ? "text-primary-600 border-b-2 border-primary-500"
                : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            }`}
            onClick={() => setLoginMethod("qr")}
          >
            QR Code Login
          </button>
        </div>

        <div className="p-8">
          {loginMethod === "traditional" ? (
            <form onSubmit={handleTraditionalLogin} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:bg-coolGray-750 text-gray-800"
                  placeholder="Enter your username"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 dark:bg-coolGray-750 text-gray-800"
                  placeholder="Enter your password"
                  required
                />
              </div>
              {error && <div className="text-red-500 text-sm">{error}</div>}
              <div className="flex items-center justify-between text-sm">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="rounded border-gray-300 text-primary-500 focus:ring-primary-500"
                  />
                  <span className="ml-2 text-gray-600 dark:text-gray-400">
                    Remember me
                  </span>
                </label>
                <a
                  href="/forgot-password"
                  className="text-primary-600 hover:text-primary-500"
                >
                  Forgot password?
                </a>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 font-semibold text-sm mt-6"
              >
                Sign In
              </button>
              {/* Added Leave Sign In Button */}
              <button
                type="button"
                onClick={handleLeaveSignIn}
                className="w-full bg-gray-200 text-gray-700 py-3 rounded-lg hover:bg-gray-300 transition-colors duration-200 font-semibold text-sm mt-2"
              >
                Leave Sign In
              </button>
            </form>
          ) : (
            <QRScanner onSuccess={handleQRLoginSuccess} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
